type FormatProp = 'numeric' | 'minutes' | 'short' | 'long' | 'full'
type Props = { time?: number; date?: Date; variant?: FormatProp }

const timeOptions: Record<FormatProp, Intl.DateTimeFormatOptions> = {
  numeric: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  minutes: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  long: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  full: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
}

export default function Timestamp({ time, date, variant = 'full' }: Props) {
  date = date || (time ? new Date(time) : undefined)
  if (!date) return null
  if (isNaN(date.getTime())) return <>-</>
  const display = date.toLocaleDateString(navigator.language, timeOptions[variant])
  return <>{display}</>
}
